import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HostBackend } from '../HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { FilterParkAndUnivers } from '../../Components/Public/Filters/FilterParkAndUnivers.js';
import { Family } from '../../Pages/Public/Family.js';
import { NotFound } from '../../Pages/Public/NotFound.js';

export const RouteFamily = () => {
    const backend = HostBackend();
    const guest = sessionStorage.getItem('guest');
    const [parks, setParks] = useState([]);
    const [fam, setFam] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const datasParks = await fetch(`${backend}/nav/parks`, GetHeaders(guest));
            const parks = await datasParks.json();
            setParks(parks);
            const dataFam = await fetch(`${backend}/nav/family`, GetHeaders(guest));
            const fam = await dataFam.json();
            setFam(fam);
        };
        fetchData();
    }, [backend, guest]);
    if (parks.err) window.location.href = '/';
    const navParks = FilterParkAndUnivers(parks);
    return (
        <BrowserRouter>
            <Routes>
                {fam.map((el, i) => {
                    return (<Route path={el.froute} element={<Family navParks={navParks} id={el.id} />} key={i} />)
                })}
                <Route path="*" element={<NotFound navParks={navParks} />} />
            </Routes>
        </BrowserRouter>
    )
}